<template>
  <div class="userdata" id="userdata">

    <div v-if="notLoggedIn" class="single-sign-on">
      
      <!-- Apple -->
      <div class="single-sign-on__button">
        <input v-model="appleLogin" type="checkbox" id="appleLogin" name="appleLogin" @change="loginTypeChecked($event)" />
        <label for="appleLogin" class="single-sign-on__button__content">
          <img src="../../assets/icons/ic_20_apple.svg">{{ $t('register.login_with_apple') }}
        </label>
      </div>

      <!-- Google -->
      <div v-if="isAndroidApp" class="single-sign-on__button">
        <input v-model="googleLogin" type="checkbox" id="googleLogin" name="googleLogin" @change="loginTypeChecked($event)" />
        <label for="googleLogin" class="single-sign-on__button__content">
          <img src="../../assets/icons/ic_20_google.svg">{{ $t('register.login_with_google') }}
        </label>
      </div>
      <!--
      <div v-else>
        <div id="g_id_onload"
             data-client_id="943145692537-elvlet8tq780g58j60gn8vb130m79eq0.apps.googleusercontent.com"
             data-context="signin"
             data-ux_mode="popup"
             data-callback="handleGoogleLogin"
             data-auto_select="true"
             data-itp_support="true">
        </div>

        <div class="g_id_signin"
             data-type="standard"
             data-shape="rectangular"
             data-theme="outline"
             data-text="signin_with"
             data-size="large"
             data-logo_alignment="left">
        </div>
      </div>
      -->
      
      <!-- Divider -->
      <div class="single-sign-on__divider">
        <div></div>
        <span style="text-transform: uppercase">{{ $t('or') }}</span>
        <div></div>
      </div>
      
    </div>
    
    <div v-if="notLoggedIn" class="input-container" style="margin-bottom: 16px;">
      <div class="input-element" v-bind:class="{ validation_true: nicknameValid === true, validation_false: name.length > 0 && nicknameValid === false }">
        <input @focusout="handleNameFocus" v-model="name" name="name" type="text" id="username" placeholder="username"/>
        <label for="username">{{ $t('user_name') }}</label>
      </div>
      <div class="input-element" v-bind:class="{ validation_true: emailValid === true, validation_false: email.length > 0 && emailValid === false }">
        <input @focusout="handleEmailFocus" v-model="email" type="email" name="email" id="email" placeholder="email"/>
        <label for="email">{{ $t('email') }}</label>
      </div>
      <div class="input-element" v-bind:class="{ validation_true: passwordValid === true, validation_false: password.length > 0 && passwordValid === false }">
        <input @focusout="handlePasswordFocus" v-model="password" type="password" name="password" id="password" placeholder="password"/>
        <label for="password">{{ $t('password') }}</label>
      </div>
    </div>

    <!--
    <div v-if="notLoggedIn" class="registerlegal">
      <div class="registerlegal__checkbox">
        <input v-on:change="agreedTOSChanged" v-model="agreedTOS" type="checkbox" id="agreedTOS" name="agreedTOS" />
        <label v-if="userlang === 'de'" for="agreedTOS">{{ $t('create_betgame.agree_terms_of_use') }} <a target="_blank" href="/termsofuse">({{ $t('create_betgame.link') }})</a> und habe die <a target="_blank" href="/privacy">{{ $t('register.data_protection') }}</a> gelesen.</label>
        <label v-else for="agreedTOS">{{ $t('create_betgame.agree_terms_of_use') }} <a target="_blank" href="/termsofuse">({{ $t('create_betgame.link') }})</a> and I have read the <a target="_blank" href="/privacy">{{ $t('register.data_protection') }}</a>.</label>
      </div>
      <div class="registerlegal__checkbox">
        <input v-on:change="isUnder18Changed" v-model="isUnder18" type="checkbox" id="isUnder18" name="isUnder18" />
        <label for="isUnder18">{{ $t('create_betgame.i_am_under_18') }} ({{ $t('create_betgame.optional') }})</label>
      </div>
    </div>
    -->
    <!--
    <div v-if="notLoggedIn" class="input-container" style="margin-bottom: 32px;">
      <div class="input-header">
        {{ $t('create_betgame.conditions_and_data_protection') }}
      </div>
      <div class="input-checkbox">
        <input v-on:change="agreedTOSChanged" id="agreedTOS" name="agreedTOS" type="checkbox" v-model="agreedTOS"/>
        <label for="agreedTOS">{{ $t('create_betgame.agree_terms_of_use') }} <a target="_blank" href="/termsofuse">({{ $t('create_betgame.link') }})</a>.</label>
      </div>
      <div class="input-empty">
        <a target="_blank" href="/privacy">{{ $t('create_betgame.data_protection_teamtip') }}</a>
      </div>
      <div class="input-checkbox">
        <input v-on:change="isUnder18Changed" id="isUnder18" name="isUnder18" type="checkbox" v-model="isUnder18"/>
        <label for="isUnder18">{{ $t('create_betgame.i_am_under_18') }} <span style="font-size: 14px; opacity: .48;">({{ $t('create_betgame.optional') }})</span></label>
      </div>
    </div>
    -->
  </div>
</template>

<script>

import Vue from 'vue'
import APIService from '@/services/APIService'

export default {
  name: 'UserData',
  components: {},
  props: {
    name: 'String',
    email: 'String'
  },
  data () {
    return { 
      password: '',
      agreedTOS: false,
      isUnder18: false,
      appleLogin: false,
      googleLogin: false
    }
  },
  beforeCreate () {
    Vue.$log.debug('UserData.beforeCreate ' + this.email)
  },
  created () {
    Vue.$log.debug('UserData.created ' + this.email)
  },
  mounted () {
    Vue.$log.debug('UserData.mounted ' + this.email)
    window.addEventListener('google-auth', this.onGoogleAuth);
    window.addEventListener('google-signout', this.onGoogleSignout);

    window.handleGoogleLogin = function(token) {
      if(token) {
        if(token.credential) {
          window.localStorage.setItem('gatoken', token.credential)
          window.location.href = '/googleauth?token=' + token.credential
        } else {
          window.localStorage.setItem('gatoken', token)
          window.location.href = '/googleauth?token=' + token
        }
      } else {
        alert('Login with Google failed: 0004')
      }
    }
  },
  computed: {
    isAndroidApp() {
      return window.AndroidBridge && window.AndroidBridge.signInWithGoogle
    },
    userlang () {
      return this.$store.state.language
    },
    notLoggedIn() {
      return !this.$store.getters.loggedIn
    },
    nicknameValid () {
      if(this.name === null || this.name === undefined) {
        return false
      }
      return this.name.trim().length >= 3 && this.name.trim().length < 100
    },
    emailValid () {
      if(this.email === null || this.email === undefined) {
        return false
      }
      const valid = this.isValidEmail(this.email)
      return valid
    },
    passwordValid () {
      if(this.password === null || this.password === undefined) {
        return false
      }
      return this.password.trim().length >= 8 && this.password.trim().length < 100
    }
  },
  methods: {
    loginTypeChecked(event) {
      if(event.target.id === 'appleLogin') {
        this.appleLogin = event.target.checked
        this.$store.dispatch('setCreateBetgame', {
          key: 'appleLogin',
          value: this.appleLogin
        })
        if(this.appleLogin) {
          this.googleLogin = false
          this.$store.dispatch('setCreateBetgame', {
            key: 'googleLogin',
            value: false
          })
        }
      } else if(event.target.id === 'googleLogin') {
        this.googleLogin = event.target.checked
        this.$store.dispatch('setCreateBetgame', {
          key: 'googleLogin',
          value: this.googleLogin
        })
        if(this.googleLogin) {
          this.appleLogin = false
          this.$store.dispatch('setCreateBetgame', {
            key: 'appleLogin',
            value: false
          })
        }
      }
    },
    agreedTOSChanged() {
      //if(this.agreedTOS !== null && this.agreedTOS !== undefined) {
        this.$store.dispatch('setCreateBetgame', {
          key: 'agreedTOS',
          value: this.agreedTOS
        })
        .then(() => {
          Vue.$log.debug('AddUsers.agreedTOSChanged ok ' + this.agreedTOS)
        }).catch(function (error) {
          Vue.$log.debug('AddUsers.agreedTOSChanged error ' + error)
        })
      //}
    },
    isUnder18Changed() {
      //if(this.isUnder18 !== null && this.isUnder18 !== undefined) {
        this.$store.dispatch('setCreateBetgame', {
          key: 'isUnder18',
          value: this.isUnder18
        })
        .then(() => {
          Vue.$log.debug('UserData.isUnder18Changed ok ' + this.isUnder18)
        }).catch(function (error) {
          Vue.$log.debug('UserData.isUnder18Changed error ' + error)
        })
      //}
    },
    handleNameFocus() {
      //if(this.name && this.name.length > 3) {
        this.$store.dispatch('setCreateBetgame', {
          key: 'userName',
          value: this.name
        })
        .then(() => {
          Vue.$log.debug('UserData.handleNameFocus ok ' + this.name)
        }).catch(function (error) {
          Vue.$log.debug('UserData.handleNameFocus error ' + error)
        })
      //}
    },
    handleEmailFocus() {
      /*
      this.$store.dispatch('setCreateBetgame', {
        key: 'email',
        value: this.email
      })
      .then(() => {
        Vue.$log.debug('UserData.handleEmailFocus ok ' + this.email)
      }).catch(function (error) {
        Vue.$log.debug('UserData.handleEmailFocus error ' + error)
      })
      */
      
      if(this.email !== null && this.email !== undefined && this.isValidEmail(this.email)) {
        APIService.isEmailRegistered(this.email.toLowerCase().trim()).then(response => {
          if (response.data.valid === '1') {
            //this.emailAlreadyRegistered = false
            this.$store.dispatch('setCreateBetgame', {
              key: 'email',
              value: this.email.toLowerCase().trim()
            })
            .then(() => {
              Vue.$log.debug('UserData.handleEmailFocus ok ' + this.email)
            }).catch(function (error) {
              Vue.$log.debug('UserData.handleEmailFocus error ' + error)
            })
          } else {
            //this.emailAlreadyRegistered = true
            this.$emit('emailError', this.$t('errors.email_already_registered'))
          }
        })
      } else {
        this.$emit('emailError', this.$t('errors.enter_valid_email'))
      }
    },
    handlePasswordFocus() {
      //if(this.password && this.password.length > 3) {
        this.$store.dispatch('setCreateBetgame', {
          key: 'password',
          value: this.password
        })
        .then(() => {
          Vue.$log.debug('UserData.handlePasswordFocus ok ' + this.password)
        }).catch(function (error) {
          Vue.$log.debug('UserData.handlePasswordFocus error ' + error)
        })
      //}
    }
  }
}
</script>

<style lang="scss" scoped>

.userdata {
  max-width: 400px;
  margin: 16px auto 16px;
}

.input-container {
  margin: 0 auto;
}

.registerlegal {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 0;

  &__checkbox {
    display: flex;
    align-items: center;

    &:not(:last-of-type) {
      margin-bottom: 16px;
    }

    input {
      display: none;
    }

    label {
      position: relative;
      font-size: 14px;
      letter-spacing: -0.41px;
      font-weight: 400;
      color: rgba(var(--color-text-rgb), .64);
      padding-left: 32px;

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        width: 20px;
        height: 20px;
        background: url('../../assets/icons/ic_20_checkbox.svg');
      }
    }

    input[type="checkbox"]:checked+label:before {
      background: url('../../assets/icons/ic_20_checkbox_active.svg');
    }
  }
}

.single-sign-on {

  &__divider {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 24px 0;

    span {
      font-size: 14px;
      color: rgba(var(--color-text-rgb), .48);
      margin: 0 8px;
    }

    div {
      height: 1px;
      width: 100%;
      background: linear-gradient(90deg, var(--color-text) 0%, rgba(var(--color-text-rgb), 0) 100%);
      opacity: .12;

      &:first-of-type {
        background: linear-gradient(90deg, rgba(var(--color-text-rgb), 0) 0%, var(--color-text) 100%);
      }
    }
  }

  &__button {
    display: flex;
    width: 100%;

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    &__content {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: var(--color-surface);
      border-radius: 8px;
      padding: 16px;
      font-size: 17px;
      color: var(--color-text);
      box-shadow: 0 0 0 1px rgba(var(--color-text-rgb), .08);
      transition: all .2s ease-in-out;

      &:hover {
        box-shadow: 0 0 0 1px rgba(var(--color-text-rgb), .16);
      }

      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }

    input {
      display: none;

      &:checked ~ label {
        box-shadow: 0 0 0 2px var(--color-primary);
      }
    }
  }
}

</style>
